/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsHeader = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      if(Shopify.theme_settings.announcement_enabled == true) {
        Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin();
      }
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      Shopify.theme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      Shopify.theme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      Shopify.theme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      Shopify.theme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        Shopify.theme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        Shopify.theme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        Shopify.theme.jsHeader.showSearch();
      }
    });

    jQuery(function ($) {
      var $wrap = $(".animated-placeholder-text").first();
      if (!$wrap.length) return;

      var t1 = $.trim($wrap.find(".text-1").text());
      var t2 = $.trim($wrap.find(".text-2").text());
      var t3 = $.trim($wrap.find(".text-3").text());
      var t4 = $.trim($wrap.find(".text-4").text());
      var t5 = $.trim($wrap.find(".text-5").text());

      var texts = $.grep([t1, t2, t3, t4, t5], function (t) { return !!t; });
      if (!texts.length) return;

      $wrap.html('<span class="typing-target"></span><span class="cursor">|</span>');
      var $target = $wrap.find(".typing-target");

      var TYPE_SPEED = 90;
      var DELETE_SPEED = 55;
      var DOT_SPEED = 180;
      var HOLD_FULL = 650;
      var HOLD_AFTER_DOTS = 350;
      var HOLD_EMPTY = 250;

      var index = 0;

      function sleep(ms) {
        return $.Deferred(function (dfd) {
          setTimeout(dfd.resolve, ms);
        }).promise();
      }

      function typeWord(word) {
        var i = 1;
        $target.text("");
        function step() {
          $target.text(word.slice(0, i));
          i++;
          if (i <= word.length) {
            setTimeout(step, TYPE_SPEED);
          }
        }
        step();
        return sleep(TYPE_SPEED * word.length + 10);
      }

      function dotsCycle(word) {
        return sleep(HOLD_FULL).then(function () {
          var d = 1;
          return $.Deferred(function (dfd) {
            function stepDots() {
              $target.text(word + ".".repeat(d));
              d++;
              if (d <= 3) {
                setTimeout(stepDots, DOT_SPEED);
              } else {
                setTimeout(dfd.resolve, HOLD_AFTER_DOTS);
              }
            }
            stepDots();
          }).promise();
        });
      }

      function deleteWord(word) {
        return $.Deferred(function (dfd) {
          function removeDotsThenChars() {
            var current = $target.text();

            if (/\.$/.test(current)) {
              $target.text(current.slice(0, -1));
              setTimeout(removeDotsThenChars, DELETE_SPEED);
              return;
            }

            var len = current.length;
            if (len > 0) {
              $target.text(current.slice(0, -1));
              setTimeout(removeDotsThenChars, DELETE_SPEED);
              return;
            }

            setTimeout(dfd.resolve, HOLD_EMPTY);
          }

          removeDotsThenChars();
        }).promise();
      }

      function runLoop() {
        var word = texts[index];

        typeWord(word)
          .then(function () { return dotsCycle(word); })
          .then(function () { return deleteWord(word); })
          .then(function () {
            index = (index + 1) % texts.length;
            runLoop();
          });
      }

      runLoop();

      var inputSel = ".header__search .search-form .control .input";
      var $input = $(inputSel).first();
      var $ph = $(".animated-placeholder-text").first();
  
      if (!$input.length || !$ph.length) return;
  
      function shouldShowPlaceholder() {
        return $.trim($input.val()) === "" && !$input.is(":focus");
      }
  
      function updatePlaceholderVisibility() {
        if (shouldShowPlaceholder()) {
          $ph.stop(true, true).fadeIn(150);
        } else {
          $ph.stop(true, true).fadeOut(150);
        }
      }
  
      $(document).on("focus click", inputSel, function () {
        $ph.stop(true, true).fadeOut(150);
      });
  
      $(document).on("input", inputSel, function () {
        updatePlaceholderVisibility();
      });
  
      $(document).on("mousedown touchstart", function (e) {
        var clickedInsideInput = $(e.target).closest(inputSel).length > 0;
        if (!clickedInsideInput) {
          $input.trigger("blur");
          updatePlaceholderVisibility();
        }
      });
  
      $(document).on("blur", inputSel, function () {
        updatePlaceholderVisibility();
      });
  
      updatePlaceholderVisibility();
    });

    $(document).on("click", ".mobile-menu .normalmenu-back-btn", function () {
      var $parent4 = $(this).parents().eq(3);
      $parent4.find('input[type="checkbox"]:checked').prop("checked", false).trigger("change");
    });
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        Shopify.theme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(Shopify.theme_settings.header_layout == 'centered') {
        $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
      }

      // Get header height is sticky enabled
      if(Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');
    if(Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="'+Shopify.theme_settings.search_layout+'"]').toggleClass('is-opened');
      $('.search-form .search__fields input[type="text"]').focus();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        }
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="'+Shopify.theme_settings.search_layout+'"]').removeClass('is-opened');
    } else {
      $.fancybox.close($('[data-search-type="'+Shopify.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;